import { gql } from "@apollo/client";

export const CREATE_OFFICE = gql`
  mutation CreateOffice($input: OfficeInput) {
    createOffice(input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const UPDATE_ISUSE_OFFICE_STATUS = gql`
  mutation UpdateOfficeIsUse($id: ID!, $isUse: Boolean) {
    updateOfficeIsUse(_id: $id, isUse: $isUse) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const GET_OFFICE_PAGINATION = gql`
  query GetOfficePagination(
    $isUse: Boolean
    $keyword: String
    $pagination: Boolean
    $limit: Int
    $page: Int
  ) {
    getOfficePagination(
      isUse: $isUse
      keyword: $keyword
      pagination: $pagination
      limit: $limit
      page: $page
    ) {
      data {
        _id
        officeKhName
        officeEnName
        isUse
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_OFFICE = gql`
  mutation UpdateOffice($id: ID!, $input: OfficeInput) {
    updateOffice(_id: $id, input: $input) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const DELETE_OFFICE = gql`
  mutation DeleteOffice($id: ID!) {
    deleteOffice(_id: $id) {
      status
      message {
        messageEn
        messageKh
      }
    }
  }
`;

export const SELECT_OFFICE = gql`
  query SelectOffice($isUse: Boolean) {
    selectOffice(isUse: $isUse) {
      _id
      officeKhName
      officeEnName
      isUse
      remark
    }
  }
`;
